<template>
  <div>
    <div class="text-11 py-24 font-semibold">
      {{ t('termsOfService.version', { version: tosVersion }) }}
    </div>
    <div class="flex">
      <div class="text-17 flex-1" v-html="tosText" />
      <div class="flex-1" />
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  name: 'termsOfService',
  layout: 'terms-of-service',
});

const { locale, t } = useI18n();

const { data } = await useFetch('/api/tos');

const tosVersion = computed(() => data.value?.data?.version);
const tosText = computed(() => data.value?.data?.text[locale.value] ?? '');
</script>
